import { BaseInput, BaseInputProps } from '@service-victoria/component-library/components/Input';
import { getInputTypeForAutoCompleteOff } from '@service-victoria/component-library/utils/getInputType';
import React, { useCallback } from 'react';

import { Wrapper } from './styled';

export const InputField = React.forwardRef<HTMLInputElement, BaseInputProps>(function InputBase(
  { type = 'text', autoComplete, onBlur, ...props },
  ref
) {
  /**
   * Delaying blur event so that it can trigger onClick
   * event on any element on the page before showing the error.
   * This exists to solve an issue where clicking clear form
   * does not actually clear the form since the whole page
   * is shifted down due to the error message.
   *
   * https://servicevic.atlassian.net/browse/DVR-544
   */
  const delayedOnBlur = useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      setTimeout(() => {
        onBlur?.(event);
      }, 100);
    },
    [onBlur]
  );

  return (
    <Wrapper>
      <BaseInput
        {...props}
        onBlur={delayedOnBlur}
        ref={ref}
        autoComplete='off'
        type={getInputTypeForAutoCompleteOff(type)}
        errorLabelProps={{
          'data-testid': 'inputFieldError'
        }}
      />
    </Wrapper>
  );
});

export default InputField;
